import { render, staticRenderFns } from "./Index copy.vue?vue&type=template&id=25171c92&scoped=true&"
import script from "./Index copy.vue?vue&type=script&lang=js&"
export * from "./Index copy.vue?vue&type=script&lang=js&"
import style0 from "./Index copy.vue?vue&type=style&index=0&id=25171c92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25171c92",
  null
  
)

export default component.exports